export default "__VITE_ASSET__XU7g7acL__"